import React, { useState } from "react";
import { AiOutlinePlus } from "react-icons/ai";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { AllCampusesHooks ,handleDeleteCampus} from "./hooks/campusesHandlers";
import CustomTable from "../universal/CustomTable";
import ConfirmToast from "../universal/ConfirmToast";
import CampusModal from "./CampusModal";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
const allCampusesHeader = [
  { headerName: "Campus Name", headerId: "campusName" },
  { headerName: "Description", headerId: "campusDescription" },
  { headerName: "Actions", headerId: "actions" },
];

function AllCampuses({ church }) {
  const { reloadData, setReloadData, fetchAllCampuses, dispatch } = AllCampusesHooks();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);

  return (
    <>
    {
      church?
    <div className="App bg-[#191919]">
      <div className="relative p-4">
        <div className="flex gap-4 absolute right-4 mt-2">
          <button
            onClick={() => setIsModalOpen(true)}
            className="flex items-center gap-2 text-[13px] text-yellowish border px-4 py-2 border-yellowish bg-blackish rounded-xl"
          >
            <AiOutlinePlus /> Add Campus
          </button>
        </div>

       { !isModalOpen &&

        <CustomTable
          searchFor="Campuses"
          heightDesktop="h-[72vh]"
          width="w-24"
          nthChildWidth="[&>*:nth-child(1)]:w-40 [&>*:nth-child(2)]:w-40 [&>*:nth-child(3)]:w-40 [&>*:nth-child(4)]:w-32"
          notificationTable={true}
          headers={allCampusesHeader}
          data={[]} // dynamic via callback
          customDataFetch={true}
          customDataFetchFunction={(page, limit, searchCriteria, callback) =>
            fetchAllCampuses(page, limit, searchCriteria, callback ,church?._id)
          }
          reloadData={reloadData}
          setReloadData={setReloadData}
          reverseTable={true}
          nthChildStyle="[&>*:nth-child(2)]:h-5 [&>*:nth-child(2)]:overflow-hidden"
          handleDeleteClick={(row) => {
            confirmAlert({
              customUI: ({ onClose }) => (
                <ConfirmToast
                title="Are you sure?"
                message="You want to delete this campus?"
                onClose={onClose}
                onSuccess={() => {
                  handleDeleteCampus(dispatch, row.churchId, row.campusObjId, (res) => {
                    if (res.type === 1) {
                      toast.success(" Campus deleted successfully!", {
                        position: "top-right",
                        autoClose: 3000,
                      });
                      setReloadData((prev) => !prev);
                    } else {
                      toast.error(" Failed to delete campus!", {
                        position: "top-right",
                        autoClose: 3000,
                      });
                    }
                    onClose();
                  });
                }}
              />
              ),
            });
          }}
          handleEditClick={(row) => {
                        setSelectedRow(row);
            setIsModalOpen(true);
          }}
        />
}
      </div>

      <CampusModal
        church={church}
        isOpen={isModalOpen}
        onClose={() => {
          setIsModalOpen(false);
          setSelectedRow(null);
        }}
        rowData={selectedRow}
      />
    </div>
    :
    <div className="w-full h-full flex items-center justify-center text-gray-400 ">
    <p>Add Church/Ministry/Channel First</p>
    </div>
}
    </>
  );
}

export default AllCampuses;
